// const BASE_URL = 'https://easy-bear-fedora.cyclic.app/api/v1'
const BASE_URL = 'https://backend-sinko-14a1ba47ff05.herokuapp.com/api/v1'


export { BASE_URL }
